import React from 'react'

function TabTittle(newTitle) {
  return (document.title = newTitle)
}

export default TabTittle